import { navigate } from 'gatsby';
import React from 'react';

import { EMERGENCY_ACCESS } from '../constants/routes';

export default function EmergencyPage() {
  React.useEffect(() => {
    navigate(EMERGENCY_ACCESS);
  }, []);
  return null;
}
